import React, { useEffect, useState } from "react";
import Header from "../Header/Header";

interface NavbarProps {
  hclass?: string;
}

const Navbar: React.FC<NavbarProps> = ({ hclass }) => {
  const [scroll, setScroll] = useState<number>(0);

  useEffect(() => {
    const handleScroll = () => setScroll(document.documentElement.scrollTop);

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const className = scroll > 80 ? "fixed-navbar active" : "fixed-navbar";

  return (
    <div className={className}>
      <Header hclass={hclass}/>
    </div>
  );
};

export default Navbar;
